<template>
    <div
        v-if="!isEmptyArray(data)"
        class="el-breadcrumb box"
    >
        <span
            v-for="(item, index) in data"
            :key="index"
            class="el-breadcrumb__item"
        >
            <span
                class="el-breadcrumb__item__inner"
                @click="onClick(index)"
            >{{ item[0] }}</span>
            <span class="el-breadcrumb__separator">/</span>
        </span>
    </div>
</template>

<script>
import { isEmptyArray } from '@lsfe/tools';
import { crumb } from 'data';

export default {
    data() {
        const path = window.location.pathname.slice(1, -5);
        const data = crumb[path] || [];
        return { data, isEmptyArray };
    },
    methods: {
        onClick(index) {
            const url = this.data[index][1];
            if (url) {
                location.href = url;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.box {
    padding: 15px 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.03);
    &:empty {
        display: none;
    }
}
</style>
